import { KeyValuePipe, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InternalStatusMessage } from './../../models';
import { ErrorKeyPipe } from './../../pipes';

@Component({
    selector: 'lib-validation-input-message',
    standalone: true,
    imports: [TranslateModule, NgStyle, KeyValuePipe, ErrorKeyPipe],
    template: `
        <div [ngStyle]="{ 'min-height': '1.875rem' }" class="ps-1 mb-1">
            @if (statusMessage) {
            <small role="alert" aria-label="Errore di validazione" [attr.class]="statusClass"
                ><strong>{{ statusMessage!.text | translate : statusMessage.params }}</strong></small
            >
            } @else if (fcErrors){ @for (item of fcErrors | keyvalue | errorKey : 'pattern' : 'required'; track $index)
            {

            <small role="alert" aria-label="Errore di validazione" class="status-danger"
                ><strong>{{
                    ('required' === item.key ? 'VALIDATIONS.REQUIRED' : 'VALIDATIONS.PATTERN.REGEXP') | translate
                }}</strong></small
            >
            } }
        </div>
    `
})
export class ValidationInputMessagesComponent {
    @Input() statusMessage!: InternalStatusMessage | null;
    @Input() fcErrors!: Record<string, unknown>;

    get statusClass(): string {
        return this.statusMessage?.status ? `status-${this.statusMessage?.status}` : 'status-basic';
    }
}
